module.exports = __webpack_public_path__ + "media/images/snek-270d72b5dad7eac50e19e579999504f2.png";